import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import modules
import {
  User,
  PhoneDevice,
  AddressBook,
  CallHistory,
  AddressExchangeToken,
} from './modules'

const store = new Vuex.Store({
  plugins: [
    createPersistedState()
  ],
  modules: {
    user: User,
    phoneDevice: PhoneDevice,
    addressBook: AddressBook,
    callHistory: CallHistory,
    addressExchangeToken: AddressExchangeToken,
  }
})

export default store